import ApplicationController from "../../application_component_controller";

import { GridStack } from "gridstack";
import { useEditing } from "hb/insights/use_editing";
import { useOutlets } from "hb/insights/use_outlets";
import { useListen } from "hb/insights/use_listen";
import { groupReduce } from "hb/lib/collection_helpers";

export default class extends ApplicationController {
  static values = {
    queryPath: String,
    dashboardId: String,
    dashboardsPath: String,
  };

  connect() {
    this.grid = GridStack.init({
      disableDrag: true,
      disableResize: true,
      margin: 4,
      cellHeight: "100px",
    });

    this.element.classList.remove("loading");
    useEditing(this);
    useOutlets(this, {
      scope: this.element,
      components: ["grid-item"],
    });
    useListen(this);
  }

  outletsConnected() {
    this.outletComponents("grid-item").forEach((c) => c.gridLoaded());
  }

  add() {
    this.emitWindow("dashboard:openAddWidget");
  }

  edit() {
    this.grid.enable();
  }

  cancel() {
    this.grid.disable();
  }

  save() {
    this.grid.disable();

    const finalItems = this.outletComponents("grid-item").filter((c) => {
      return !c.checkAndDelete();
    });

    const gridItems = groupReduce(
      this.grid.save(true, false, undefined, 12),
      (g) => g.id,
    );
    return finalItems.map((c) => c.save(gridItems[c.id]));
  }
}
